// このファイルは自動生成されています。直接編集しないでください。
// 更新する場合は `bundle exec rails master_constants_for_frontend:generate_ts` を実行してください。

export const EMPLOYMENT = {
  REGULAR_MEMBER_ID: 1, // 正社員
  OTHER_ID: 2, // その他
  CONTRACT_EMPLOYEE_ID: 3, // 契約社員
  BUSINESS_CONSIGNMENT_ID: 4, // 業務委託
  ARBEIT_PART_ID: 5, // アルバイト・パート
} as const;

export type EmploymentId = (typeof EMPLOYMENT)[keyof typeof EMPLOYMENT];
